import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { BankIDFormTextKeys } from '~/components/authentication/bankid/bankid-text-keys';
import { BANKID_MODES, BANKID_SCREEN } from '~/components/authentication/bankid/configs';
import { updateCredentials } from '~/components/authentication/ducks';
import Loading from '~/components/misc/loading';
import useTranslations from '~/components/translation/use-translations';

import BankIdQRCode from './qr-code';

const BankIDForm = ({
	mode = BANKID_MODES.LOGIN,
	title,
	onSubmit,
	loading,
	gaEventCb = () => {},
	setPollConfig,
	onCancel,
	transaction = {},
	screen,
	isQrEnabled
}) => {
	const dispatch = useDispatch();

	const { isLoadingTranslations } = useTranslations(BankIDFormTextKeys);

	const config = useMemo(
		() => ({
			transaction,
			gaEventCb,
			loading,
			mode,
			onCancel,
			onSubmit,
			setPollConfig,
			title,
			isQrEnabled
		}),
		[transaction, gaEventCb, loading, mode, onCancel, onSubmit, setPollConfig, title, isQrEnabled]
	);

	useEffect(() => {
		if (screen) {
			const interval = screen === BANKID_SCREEN.QR ? 1_000 : 2_000;

			setPollConfig({ duration: 40_000, interval });
		}
	}, [screen, setPollConfig]);

	useEffect(() => {
		if (screen) {
			dispatch(
				updateCredentials({ registrationPixelType: screen === BANKID_SCREEN.QR ? ' - qr-code' : ' - bankID' })
			);
		}
	}, [dispatch, screen]);

	if (isLoadingTranslations) {
		return <Loading />;
	}

	return <BankIdQRCode {...config} />;
};

export default BankIDForm;
